import React from 'react';
import { useSelector } from 'react-redux';
import { IconError } from '../../../../component';

export const ErrorState = (): JSX.Element => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../nls/${preference.language.id}.json`);
  return (
    <div className="socioeconomic-empty-state">
      <IconError cy="FetchSocioeconomicError" />
      <h2>{nls.fetchError}</h2>
      <p>{nls.descriptionFetchError}</p>
    </div>
  );
};
